
export const MAX_ROWS = 747849;
export const SITE_IDKEY = 'user-site-id';
export const FILTER_CACHE_KEY = 'current_data_filter';
export const PERFORMANCE_FILTER_CACHE_KEY = 'current_performance_report_filter';
export const USER_DETAIL = 'INDOOR-USER-DETAIL';
